import { createApi } from '@reduxjs/toolkit/query/react'
import { authCustomFetchBase } from '../mutexCustomFetchBase'
import { cacher } from '../rtkQueryCacheUtils'

export const TENANT_API_REDUCER_KEY = 'tenantApi'

// Pure configuration: the endpoints live in the generated modules under ../tenant, injected at
// import time, and their cache tags in the sibling <module>CacheTags.ts / <module>Enhanced.ts
// pairs. Defining an endpoint here again would only be overridden by the generated injection
// (overrideExisting: true) - endpointUniqueness.test.js fails if anyone tries.
export const tenantApi = createApi({
  reducerPath: TENANT_API_REDUCER_KEY,
  baseQuery: authCustomFetchBase,
  tagTypes: [
    ...cacher.defaultTags,
    'Tenants',
    'TenantTheme',
    'EmployeeIdConfig',
    'Courses',
    // The tenant's view of a course, distinct from the global 'Courses' catalogue above.
    'TenantCourses',
    'CourseVariants',
    'Subscriptions',
    'SubscriptionCourseViews',
    'ProvisionedCourses',
    'Trainings',
    'MyTrainingParticipations',
    'LearnerCourses',
    'TrainingCycles',
    'CycleEnrollments',
    'TrainingRecordsExport',
    'CourseHistory',
    'MyTrainingParticipations',
    'TenantNotes',
    'Users',
    'Notifications',
  ],
  endpoints: () => ({}),
  // Tags only know about writes made through this app instance; learners also change via
  // SCIM sync and CSV import jobs, subscriptions via backend sync, and anything via another
  // admin's browser. The 60-second staleness window on remount covers those.
  refetchOnMountOrArgChange: 60,
})
